// extracted by mini-css-extract-plugin
export default {"Blur":"CheckImage_Blur__0mjbf","ColorSelected":"CheckImage_ColorSelected__34-dv","PhotoSelected":"CheckImage_PhotoSelected__nYPPm"};